import authWithGoogle from './auth-with-google';
import register from './register';
import login from './login';

export default {
  authWithGoogle,
  register,
  login,
};
